"use client";

import {
  createContext,
  useContext,
  useMemo,
  useState,
  SetStateAction,
  Dispatch,
  PropsWithChildren,
} from "react";

interface TabsContextType {
  activeTab?: string;
  setActiveTab?: Dispatch<SetStateAction<string | string>>;
}

export const TabContext = createContext<TabsContextType>({});

export function TabContextProvider({
  children,
  defaultTab,
}: PropsWithChildren<TabsContextType & { defaultTab: string }>) {
  const [activeTab, setActiveTab] = useState(defaultTab);

  const statsInfo = useMemo(() => ({ activeTab, setActiveTab }), [activeTab]);

  return <TabContext value={statsInfo}>{children}</TabContext>;
}

export const useTabInfo = () => {
  const tabInfo = useContext(TabContext);
  return tabInfo;
};
